import { Component, OnInit} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CommonHttpService } from '../../commonHttp.service';
import { LoaderService } from '../../../_shared/services/loader.service';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.css']
})
export class SubscribeComponent implements OnInit {
	baseUrl: any = environment.apiUrl;
  subscriberEmail: any;
  subscribed: boolean = false;
  duplicateError: boolean = false;
  success: boolean = false;
  sendData: any;

  constructor(private service: CommonHttpService, private loaderService: LoaderService) { }

  ngOnInit() {
  }

  subscribe() {
    //this.loaderService.display(true);
    this.sendData = { SubscriberId: 0, SubscriberMail: this.subscriberEmail}

    this.service.create(this.baseUrl + 'SubscriberAPI/AddSubscriber', this.sendData)
      .subscribe(
        data => {
          console.log(data)
          this.success = true;
          if(data.isSuccess == true){
            this.subscribed = true;
            this.subscriberEmail = ''; 
            this.duplicateError = false
          }
          else{
            this.subscribed = false;
            this.subscriberEmail = ''; 
            this.duplicateError = true;
          }       
          this.loaderService.display(false);
        },
        (error) => {
          this.loaderService.display(false);
        })
  }

}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/home/subscribe/subscribe.component.ts